/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { Delete } from '../fn/users/delete';
import { Delete$Params } from '../fn/users/delete';
import { Get } from '../fn/users/get';
import { Get$Params } from '../fn/users/get';
import { List } from '../fn/users/list';
import { List$Params } from '../fn/users/list';
import { ResetTwoFactor } from '../fn/users/reset-two-factor';
import { ResetTwoFactor$Params } from '../fn/users/reset-two-factor';
import { Save } from '../fn/users/save';
import { Save$Params } from '../fn/users/save';
import { SetPassword } from '../fn/users/set-password';
import { SetPassword$Params } from '../fn/users/set-password';
import { UserModel } from '../models/user-model';
import { UserViewModelPrimeDatatableResults } from '../models/user-view-model-prime-datatable-results';

@Injectable({ providedIn: 'root' })
export class UsersApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiUsersListPost()` */
  static readonly ApiUsersListPostPath = '/api/Users/List';

  /**
   * List Clients.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `List()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  List$Response(params?: List$Params, context?: HttpContext): Observable<StrictHttpResponse<UserViewModelPrimeDatatableResults>> {
    return List(this.http, this.rootUrl, params, context);
  }

  /**
   * List Clients.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `List$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  List(params?: List$Params, context?: HttpContext): Observable<UserViewModelPrimeDatatableResults> {
    return this.List$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserViewModelPrimeDatatableResults>): UserViewModelPrimeDatatableResults => r.body)
    );
  }

  /** Path part for operation `apiUsersGetPost()` */
  static readonly ApiUsersGetPostPath = '/api/Users/Get';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `Get()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  Get$Response(params?: Get$Params, context?: HttpContext): Observable<StrictHttpResponse<UserModel>> {
    return Get(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `Get$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  Get(params?: Get$Params, context?: HttpContext): Observable<UserModel> {
    return this.Get$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserModel>): UserModel => r.body)
    );
  }

  /** Path part for operation `apiUsersSavePost()` */
  static readonly ApiUsersSavePostPath = '/api/Users/Save';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `Save()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  Save$Response(params?: Save$Params, context?: HttpContext): Observable<StrictHttpResponse<UserModel>> {
    return Save(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `Save$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  Save(params?: Save$Params, context?: HttpContext): Observable<UserModel> {
    return this.Save$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserModel>): UserModel => r.body)
    );
  }

  /** Path part for operation `apiUsersDeletePost()` */
  static readonly ApiUsersDeletePostPath = '/api/Users/Delete';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `Delete()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  Delete$Response(params?: Delete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return Delete(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `Delete$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  Delete(params?: Delete$Params, context?: HttpContext): Observable<void> {
    return this.Delete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiUsersResetTwoFactorPost()` */
  static readonly ApiUsersResetTwoFactorPostPath = '/api/Users/ResetTwoFactor';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ResetTwoFactor()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  ResetTwoFactor$Response(params?: ResetTwoFactor$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return ResetTwoFactor(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ResetTwoFactor$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  ResetTwoFactor(params?: ResetTwoFactor$Params, context?: HttpContext): Observable<void> {
    return this.ResetTwoFactor$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiUsersSetPasswordPost()` */
  static readonly ApiUsersSetPasswordPostPath = '/api/Users/SetPassword';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `SetPassword()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  SetPassword$Response(params?: SetPassword$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return SetPassword(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `SetPassword$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  SetPassword(params?: SetPassword$Params, context?: HttpContext): Observable<void> {
    return this.SetPassword$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
